import React from "react";
import {useLocation, useParams} from "react-router";
import UserList from "./list";
import UserDetail from "./detail";
import InviteRanking from "./inviteRanking";

export default function UserTab() {
  const {userNo} = useParams();
  const location = useLocation();

  if (location.pathname === "/user/invite-ranking") {
    return <InviteRanking/>;
  }
  if (userNo) {
    return <UserDetail/>;
  }
  return <UserList/>;
}
